import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
// import LayOut from '../views/layOut/layOut.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // redirect:'/',
    name: 'index',
    component: index,
    meta: { keepAlive: false },
  },
  {
    path: '/',
    name: 'LayOut',
    // redirect: '/index',
    // component: LayOut,
    component: () => import('../views/layOut/layOut.vue'),
    children: [
      {
        path: '/theme',
        name: 'theme',
        component: () => import('../views/theme/theme.vue'),
        meta: { keepAlive: false },
      },
      {
        path: '/themeDetails',
        name: 'themeDetails',
        component: () => import('../views/theme/themeDetails2.vue'),
        meta: { keepAlive: false },
      },
      {
        path: '/serviceHall',
        name: 'serviceHall',
        component: () => import('../views/serviceHall/serviceHall.vue'),
        meta: { keepAlive: true },
      },
      {
        path: '/serviceDetails',
        name: 'serviceDetails',
        component: () => import('../views/serviceHall/serviceDetails.vue'),
        meta: { keepAlive: false },
      },
      {
        path: '/fileDetails',
        name: 'fileDetails',
        component: () => import('../views/serviceHall/fileDetails.vue'),
        meta: { keepAlive: false },
      },
      {
        path: '/detailedList',
        name: 'detailedList',
        component: () => import('../views/detailedList.vue'),
        meta: { keepAlive: true },
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import('../views/notice/noticeList.vue'),
        meta: { keepAlive: false },
      },
      {
        path: '/noticeDetails',
        name: 'noticeDetails',
        component: () => import('../views/notice/noticeDetails.vue'),
        meta: { keepAlive: false },
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('../views/search.vue'),
        meta: { keepAlive: true },
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
  },
  {
    path: '/notfound',
    name: 'notfound',
    component: () => import('../views/404.vue'),
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import('../components/Preview.vue'),
    meta: { keepAlive: false },
  },
  {
    /**
     * 进行我们的路由匹配，通俗来讲就是比如我们是http://localhost:8080
     * 匹配我们/后面的如果你乱写的话就会重定向我们的404路由
     * 举个例子
     *   { path: '/user-:afterUser(.*)',      redirect: '/notfound},
     * 匹配我们/user后面的内容，如果你乱写的话就会进入404
     */
    path: '/:pathMatch(.*)*',
    redirect: '/notfound'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})
// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
// router.beforeEach((to, from, next) =>{
//   if (!sessionStorage.getItem('ly-portal-affairs-ui-userLogin')) { //如果缓存中无身份凭证
//     if (to.path === '/login') {
//       next()
//     } else {
//       next({ path: "/login", replace: true });
//     }
//   }else{
//     next()
//   }
// })

export default router
